import { NativeDateAdapter } from '@angular/material/core';
import { Injectable } from '@angular/core';
import { parseToDdMmYyyy } from './dateUtils';

const DATE_FORMATS = {
    ddMMyyyy: 'dd.MM.yyyy',
    MMMYYYY: 'MMM YYYY'
};

export const DATE_LOCALE = {
    EN_UK: 'en-uk',
    DE: 'de-DE'
};

@Injectable()
export class ApplicationDateAdapter extends NativeDateAdapter {
    // Define custom date formats and their corresponding formatting methods
    protected DATE_FORMATTING_OPTIONS = {
        [DATE_FORMATS.ddMMyyyy]: {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        },
        [DATE_FORMATS.MMMYYYY]: {
            year: 'numeric',
            month: 'short'
        }
    };

    // Define custom date formats and their corresponding parsing methods
    private DATE_PARSERS = {
        [DATE_FORMATS.ddMMyyyy]: (date: string) => parseToDdMmYyyy(date)
    };

    // Override the parse method to ensure correct parsing
    override parse(value: string, parseFormat: string): Date | null {
        return this.DATE_PARSERS[parseFormat]
            ? this.DATE_PARSERS[parseFormat](value)
            : super.parse(value, parseFormat);
    }

    getDateLocale = (displayFormat: string) => {
        return displayFormat === DATE_FORMATS.MMMYYYY
            ? DATE_LOCALE.DE
            : DATE_LOCALE.EN_UK;
    };

    // Override format method to ensure correct display format
    override format(date: Date, displayFormat: string): string {
        return this.DATE_FORMATTING_OPTIONS[displayFormat]
            ? date.toLocaleDateString(
                this.getDateLocale(displayFormat),
                this.DATE_FORMATTING_OPTIONS[
                    displayFormat
                ] as Intl.DateTimeFormatOptions
            )
            : super.format(date, displayFormat);
    }
}